import { createFileRoute } from "@tanstack/react-router";
import { Generations } from "@/features/generations";

// Plain validator, not zod: route search validators stay in the eagerly
// loaded route tree, so a zod schema here would put zod in the entry chunk.
// Absent → undefined; present but not a number → the default.
function optionalNumber(value: unknown, fallback: number): number | undefined {
  if (value === undefined) return undefined;
  return typeof value === "number" ? value : fallback;
}

function validateGenerationsSearch(search: Record<string, unknown>): {
  page?: number;
  pageSize?: number;
} {
  return {
    page: optionalNumber(search.page, 1),
    pageSize: optionalNumber(search.pageSize, 12),
  };
}

export const Route = createFileRoute("/_authenticated/generations/")({
  validateSearch: validateGenerationsSearch,
  component: Generations,
});
